import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=46d324de&scoped=true"
import script from "./order-add-or-update.vue?vue&type=script&lang=js"
export * from "./order-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./order-add-or-update.vue?vue&type=style&index=0&id=46d324de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d324de",
  null
  
)

export default component.exports